import React from "react";

import { NavLink } from "react-router-dom";

import {
  SidebarMenu as SidebarMenuTelluriaUi,
  SidebarMenuProps as SidebarMenuPropsTelluriaUi
} from "@npm-telluria-tecnologia/telluria-ui";

interface SidebarMenuProps extends SidebarMenuPropsTelluriaUi {
  link: string;
}

const SidebarMenu: React.FC<SidebarMenuProps> = ({
  id,
  title,
  icon,
  identifierColor,
  link
}) => (
  <NavLink to={link}>
    <SidebarMenuTelluriaUi
      key={`${id}_${title}`}
      id={id}
      title={title}
      icon={icon}
      identifierColor={identifierColor}
    />
  </NavLink>
);

export default SidebarMenu;
